

















































































































































































































































































































import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import { ISnackbar, Settings } from '@/model'
import { ScriptSendParams } from '@/generated/model/scriptSendParams'
import { LOCALES} from '@/i18n/locales'
import VueCookies from 'vue-cookies'
import { mapGetters } from 'vuex'
import { permissions } from '@/userUtils'
import StatusIcon from '@/components/StatusIcon.vue'

Vue.use(VueCookies)

interface MeasurementUnit {
  id: Settings.UnitsEnum,
  title: string
}

@Component({
  components: {
    StatusIcon: StatusIcon,
  },
  computed: {
    ...mapGetters('user', ['userPermissions']),
    ...mapGetters('settings', ['isSaving', 'statusSocketServer'])
  }
})
export default class SettingsComponent extends Vue {
  @Prop() settings!: Settings

  private valid: boolean = false
  private userPermissions!: string[]
  private snackBar: ISnackbar = {show: false, text: '', color: '', timeout: 10000}
  private dbEnabled: boolean = false
  private isSaving!: boolean
  private patternValidationEnabled: boolean = false
  private patternGenerationEnabled: boolean = false
  private statusSocketServer!: string
  private currentStatus: string = 'unknown'
  private initialSettings: Settings = JSON.parse(JSON.stringify(this.settings))

  private ftpTransferModes: ScriptSendParams.FtpTransferModeEnum[] = [
      ScriptSendParams.FtpTransferModeEnum.ACTIVE,
      ScriptSendParams.FtpTransferModeEnum.PASSIVE
  ]

  // noinspection JSUnusedLocalSymbols,JSMismatchedCollectionQueryUpdate
  private unitList: MeasurementUnit[] = [
    { id: Settings.UnitsEnum.METRIC, title: 'settings.unitsMetric' },
    { id: Settings.UnitsEnum.IMPERIAL, title: 'settings.unitsImperial' }
  ]

  created () {
    if (this.settings.sendToRobotParams == null) {
      this.settings.sendToRobotParams = {}
    }
    if (this.settings.dbParams == null) {
      this.settings.dbParams = {
        enabled: false
      }
    }
    if (this.settings.ppParams == null) {
      this.settings.ppParams = {
        validationEnabled: false
      }
    }
    if (this.settings.pgParams == null) {
      this.settings.pgParams = {
        enabled: false
      }
    }
    this.dbEnabled = this.settings.dbParams.enabled || false
    this.patternValidationEnabled = (this.dbEnabled && this.settings.ppParams.validationEnabled) || false
    this.patternGenerationEnabled = (this.dbEnabled && this.settings.pgParams.enabled) || false
    this.currentStatus = (this.patternValidationEnabled) ? this.statusSocketServer : 'unknown'
  }

  // noinspection JSUnusedLocalSymbols
  private save () {
    if (this.settings.sendToRobotParams) {
      this.settings.sendToRobotParams.port = this.getInteger (this.settings.sendToRobotParams.port)
    }
    if (this.settings.dbParams) {
      this.settings.dbParams.port = this.getInteger (this.settings.dbParams.port)
    }
    if (this.settings.ppParams) {
      this.settings.ppParams.port = this.getInteger (this.settings.ppParams.port)
      this.settings.ppParams.timeoutSeconds = this.getInteger (this.settings.ppParams.timeoutSeconds)
    }
    if (this.settings.pgParams) {
      this.settings.pgParams.port = this.getInteger(this.settings.pgParams.port)
    }
    Vue.$cookies.set('rcLanguage', this.$i18n.locale)
    this.$emit('save', this.settings)
    this.currentStatus = this.statusSocketServer
  }

  private getInteger (value: any) {
    if (value != null && typeof value === 'string') {
      return ((value as string).length > 0) ? parseInt(value, 10) : undefined
    }
    return value
  }

  // noinspection JSUnusedLocalSymbols
  private cancel () {
    this.$emit('cancel')
  }

  private unitItems(): MeasurementUnit[] {
    return this.unitList.map(p => ({title: this.$t(p.title), id: p.id} as MeasurementUnit))
  }

  private languageItems(): object[] {
    return LOCALES.map(p => ({ value: p.value, text: p.caption, disabled: false }))
  }

  get form (): any {
    return this.$refs.form as any
  }

  private checkPort(value: string): boolean | string {
    if ((value == null || value.length === 0)
        && this.settings.sendToRobotParams != null
        && this.settings.sendToRobotParams.server != null
        && this.settings.sendToRobotParams.server.length > 0) {
      return String(this.$t('general.required'))
    }
    return true
  }

  private requiredDb(value: string): boolean | string {
    if ((value == null || value.length === 0) && this.dbEnabled) {
      return String(this.$t('general.required'))
    }
    return true
  }

  private requiredValidation(value: string): boolean | string {
    if ((value == null || value.length === 0) && this.patternValidationEnabled) {
      return String(this.$t('general.required'))
    }
    return true
  }

  private requiredPatternGeneration(value: string): boolean | string {
    if ((value == null || value.length === 0) && this.patternGenerationEnabled) {
      return String(this.$t('general.required'))
    }
    return true
  }

  private isNumeric(value: string): boolean | string {
    if (value != null && value.length > 0 && !/^\d+$/.test(value)) {
      return String(this.$t('general.numberRequired'))
    }
    return true
  }

  private isLargerThanZero(v: any): boolean | string {
    return ((!v) || (v > 0)) || `${String(this.$t('general.atleast'))} 1`
  }

  private isDisabledField(): boolean {
    return !this.userPermissions.includes(permissions.MODIFYSETTINGS)
  }

  private isDisabledDBConnection(): boolean {
    return !this.userPermissions.includes(permissions.MODIFYMACHINESETTINGS) // => service user
  }

  private checkDisabledSettings(check: (() => boolean)) {
    this.snackBar.show = false
    this.$nextTick(() => {
      if (check()) {
        this.snackBar.show = true
        this.snackBar.color = 'warning'
        this.snackBar.text = String(this.$t('settings.permissionDenied'))
        this.snackBar.timeout = 10000
      }
    })
  }

  @Watch('settings.sendToRobotParams.server')
  private strParamServerWatcher (value: boolean) {
    this.form.validate()
  }

  @Watch('valid')
  private validWatcher (value: boolean) {
    this.$emit('validate', value)
  }

  @Watch('settings.dbParams.enabled')
  private dbEnabledWatcher(value: boolean) {
    this.handleDB(value)
  }

  private handleDB (value: boolean) {
    this.dbEnabled = this.settings.dbParams!.enabled || false
    if (value) {
      if (this.settings.dbParams!.host == null) {
        this.settings.dbParams!.host = 'localhost'
      }
      if (this.settings.dbParams!.port == null) {
        this.settings.dbParams!.port = 27017
      }
    } else {
      if (this.settings.dbParams!.host != null) {
        this.settings.dbParams!.host = undefined
      }
      if (this.settings.dbParams!.port != null) {
        this.settings.dbParams!.port = undefined
      }
      if (this.settings.dbParams!.username != null) {
        this.settings.dbParams!.username = undefined
      }
      if (this.settings.dbParams!.password != null) {
        this.settings.dbParams!.password = undefined
      }
      if (this.settings.dbParams!.authSource != null) {
        this.settings.dbParams!.authSource = undefined
      }
      if (this.settings.ppParams!.validationEnabled) {
        this.settings.ppParams!.validationEnabled = false
      }
      if (this.settings.pgParams!.enabled) {
        this.settings.pgParams!.enabled = false
      }
    }
    this.updateCurrentStatus()
  }

  @Watch('settings.ppParams.validationEnabled')
  private validationEnabledWatcher(value: boolean) {
    this.handlePPParams(value)
  }

  private handlePPParams (value: boolean) {
    this.patternValidationEnabled = (this.settings.dbParams!.enabled && this.settings.ppParams!.validationEnabled) || false
    if (value) {
      if (this.settings.ppParams!.host == null) {
        this.settings.ppParams!.host = 'localhost'
      }
      if (this.settings.ppParams!.port == null) {
        this.settings.ppParams!.port = 8000
      }
    } else {
      if (this.settings.ppParams!.host != null) {
        this.settings.ppParams!.host = undefined
      }
      if (this.settings.ppParams!.port != null) {
        this.settings.ppParams!.port = undefined
      }
    }
  }

  private handlePGParams (value: boolean) {
    this.patternGenerationEnabled = (this.settings.dbParams!.enabled && this.settings.pgParams!.enabled) || false
    if (value) {
      if (this.settings.pgParams!.host == null) {
        this.settings.pgParams!.host = 'localhost'
      }
      if (this.settings.pgParams!.port == null) {
        this.settings.pgParams!.port = 5000
      }
    } else {
      if (this.settings.pgParams!.host != null) {
        this.settings.pgParams!.host = undefined
      }
      if (this.settings.pgParams!.port != null) {
        this.settings.pgParams!.port = undefined
      }
    }
  }

  @Watch('settings.ppParams.host')
  private socketHostWatcher(value: string) {
    this.updateCurrentStatus()
  }

  @Watch('settings.ppParams.port')
  private socketPortWatcher(value: number) {
    this.updateCurrentStatus()
  }

  private updateCurrentStatus () {
    const isInitialSettings = (this.settings.ppParams!.validationEnabled === this.initialSettings.ppParams!.validationEnabled
        && this.settings.ppParams!.host === this.initialSettings.ppParams!.host
        && Number(this.settings.ppParams!.port) === Number(this.initialSettings.ppParams!.port))
    this.currentStatus = (isInitialSettings) ? this.statusSocketServer : 'unknown'
  }
}
